module.exports = __webpack_public_path__ + "static/media/whiteArrow.960ce3e8.svg";